<template>
  <div class="d-flex-1-column" :style="customStyle">
    <apexchart
      v-if="!loading"
      ref="donut"
      type="donut"
      :options="chartOptions"
      :series="series"
      @legendClick="handleLegendClick"
      @dataPointSelection="handleDataPointSelection"
    ></apexchart>
    <div class="loading-container">
      <Loading v-if="loading" />
    </div>
  </div>
</template>
<script>
import { number } from 'echarts';
import Loading from '@/rex-components/rex-loading.vue';
/**
 * This is just for demo purpose
 * This code lot of generalization and work for real api integration
 *
 *
 *
 */

export const colors = ['#39B555', '#F59601', '#F16754'];
export const getColor = (index) => {
  if (index >= colors.length || index < 0) index = 0;
  return colors[index];
};

export default {
  components: { Loading },
  props: {
    customStyle: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
    apps: { type: Array, default: () => [] },
    appLabels: { type: Array, default: () => [] },
  },
  emits: ['legendClick', 'dataPointSelection'],
  computed: {
    chartOptions() {
      return {
        labels: this.appLabels,
        dataLabels: {
          enabled: false,
        },
        colors: [getColor(0), getColor(1), getColor(2)],
        responsive: [
          {
            options: {
              chart: {},
              legend: {
                show: false,
              },
            },
          },
        ],
        legend: {
          position: 'bottom',
          formatter: function (value, { seriesIndex, w }) {
            return [
              w.globals.seriesNames[seriesIndex],
              ' - ',
              (w.globals.seriesPercent[seriesIndex] | number) + '%',
            ];
          },
          labels: {
            colors: [
              'rgb(255, 255, 255)',
              'rgb(255, 255, 255)',
              'rgb(255, 255, 255)',
            ],
            useSeriesColors: false,
            onItemClick: {
              toggleDataSeries: true, // or false, depending on your requirement
            },
          },
        },
        plotOptions: {
          pie: {
            donut: {
              size: '70%',
              labels: {
                show: true,
                total: {
                  show: true,
                  showAlways: true,
                  label: this.$t('applications'),
                  fontSize: '14px',
                  fontWeight: 200,
                  color: '#FFFFFF',
                  formatter: function (w) {
                    return w.globals.seriesTotals.reduce((a, b) => {
                      return a + b;
                    }, 0);
                  },
                },
                value: {
                  show: true,
                  color: '#FFFFFF',
                  fontWeight: 700,
                  fontSize: '20px',
                },
              },
            },
          },
        },
        stroke: {
          show: false,
        },
      };
    },
  },
  data() {
    return {
      series: this.apps,
    };
  },
  watch: {
    apps: {
      deep: true,
      handler(_newValues) {
        this.series = _newValues;
        window.dispatchEvent(new Event('resize'));
      },
    },
  },
  methods: {
    handleLegendClick(chartContext, seriesIndex, config) {
      this.$emit('legendClick', chartContext, seriesIndex, config);
    },
    handleDataPointSelection(event, chartContext, config) {
      this.$emit('dataPointSelection', event, chartContext, config);
    },
  },
};
</script>
<style lang="scss">
.loading-container {
  display: flex;
}
</style>
